(function () {
  const transitionMs = 1000;
  const mobileQuery = window.matchMedia('(max-width: 860px)');
  const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  function scrollTabIntoView(tab) {
    if (!tab || !mobileQuery.matches) return;
    const scroller = tab.closest('.tahitian-guide__tabs');
    if (!scroller) return;
    const tabBounds = tab.getBoundingClientRect();
    const scrollerBounds = scroller.getBoundingClientRect();
    scroller.scrollTo({
      left: scroller.scrollLeft + tabBounds.left - scrollerBounds.left - (scroller.clientWidth - tabBounds.width) / 2,
      behavior: reducedMotionQuery.matches ? 'auto' : 'smooth'
    });
  }

  function selectTab(section, id) {
    const tabs = Array.from(section.querySelectorAll('[data-tpg-tab]'));
    const panels = Array.from(section.querySelectorAll('[data-tpg-panel]'));
    const targetPanel = panels.find((panel) => panel.dataset.tpgPanel === id);
    const activePanel = panels.find((panel) => panel.classList.contains('is-active') && !panel.hidden);
    const targetTab = tabs.find((tab) => tab.dataset.tpgTab === id);
    const shouldAnimate = !mobileQuery.matches && !reducedMotionQuery.matches;

    if (!targetPanel) return;
    if (targetPanel === activePanel) {
      scrollTabIntoView(targetTab);
      return;
    }
    if (section.tpgTransitionTimer) window.clearTimeout(section.tpgTransitionTimer);

    tabs.forEach((tab) => {
      const isActive = tab.dataset.tpgTab === id;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
    scrollTabIntoView(targetTab);

    if (!shouldAnimate) {
      panels.forEach((panel) => {
        const isTarget = panel === targetPanel;
        panel.hidden = !isTarget;
        panel.classList.toggle('is-active', isTarget);
        panel.classList.remove('is-entering', 'is-leaving');
      });
      section.tpgTransitionTimer = null;
      return;
    }

    if (activePanel) {
      activePanel.classList.remove('is-entering');
      activePanel.classList.add('is-leaving');
      activePanel.classList.remove('is-active');
    }

    targetPanel.hidden = false;
    targetPanel.classList.remove('is-leaving');
    targetPanel.classList.add('is-entering');

    window.requestAnimationFrame(() => {
      targetPanel.classList.add('is-active');
      targetPanel.classList.remove('is-entering');
    });

    section.tpgTransitionTimer = window.setTimeout(() => {
      panels.forEach((panel) => {
        const isTarget = panel === targetPanel;
        panel.hidden = !isTarget;
        panel.classList.toggle('is-active', isTarget);
        panel.classList.remove('is-entering', 'is-leaving');
      });
      section.tpgTransitionTimer = null;
    }, transitionMs);
  }

  function bindMobileSwipe(section) {
    if (section.tpgSwipeBound) return;

    const stage = section.querySelector('.tahitian-guide__stage');
    if (!stage) return;

    let startX = 0;
    let startY = 0;
    let tracking = false;

    stage.addEventListener('touchstart', (event) => {
      if (!mobileQuery.matches || event.touches.length !== 1) return;
      if (event.target.closest('.tahitian-guide__card--scroll-grades .tahitian-guide__grades')) return;

      const touch = event.touches[0];
      startX = touch.clientX;
      startY = touch.clientY;
      tracking = true;
    }, { passive: true });

    stage.addEventListener('touchend', (event) => {
      if (!tracking || !mobileQuery.matches) return;
      tracking = false;

      const touch = event.changedTouches[0];
      if (!touch) return;

      const deltaX = touch.clientX - startX;
      const deltaY = touch.clientY - startY;
      if (Math.abs(deltaX) < 54 || Math.abs(deltaX) < Math.abs(deltaY) * 1.35) return;

      const tabs = Array.from(section.querySelectorAll('[data-tpg-tab]'));
      const activeIndex = tabs.findIndex((tab) => tab.classList.contains('is-active'));
      if (activeIndex < 0) return;

      const nextIndex = deltaX < 0 ? activeIndex + 1 : activeIndex - 1;
      const nextTab = tabs[nextIndex];
      if (nextTab) selectTab(section, nextTab.dataset.tpgTab);
    }, { passive: true });

    section.tpgSwipeBound = true;
  }

  function initializeGuide(section) {
    const tabs = Array.from(section.querySelectorAll('[data-tpg-tab]'));
    const panels = Array.from(section.querySelectorAll('[data-tpg-panel]'));
    const activeTab = section.querySelector('[data-tpg-tab].is-active') || tabs[0];
    const activeId = activeTab && activeTab.dataset.tpgTab;

    tabs.forEach((tab) => {
      const isActive = tab.dataset.tpgTab === activeId;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    panels.forEach((panel) => {
      const isActive = panel.dataset.tpgPanel === activeId;
      panel.hidden = !isActive;
      panel.classList.toggle('is-active', isActive);
      panel.classList.remove('is-entering', 'is-leaving');
    });

    scrollTabIntoView(activeTab);
    bindMobileSwipe(section);
  }

  document.addEventListener('click', (event) => {
    const tab = event.target.closest('[data-tpg-tab]');
    if (!tab) return;

    const section = tab.closest('[data-tahitian-guide]');
    if (!section) return;

    event.preventDefault();
    selectTab(section, tab.dataset.tpgTab);
  });

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-tahitian-guide]').forEach((section) => {
      initializeGuide(section);
    });
  });
})();
